import * as yup from "yup";
import { Max, Min, Validation } from "../../utils/Validation.utils";
export const PriorityStatusInitialValues = {
    name: "",
    colorHex: "",
    sortOrder: undefined,
    throwConfetti: false,
    simpleEmailTemplateId: null
};
export const PriorityStatusSchema = yup.object().shape({
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.Name, Validation.Max)
        .required(Validation.Required),
    colorHex: yup.string().required(Validation.Required)
});
